/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 * 
 * see more options
 * @see https://swiperjs.com/demos
*/
// import function to register Swiper custom elements
import { Swiper } from 'swiper';
import { Navigation, Autoplay, Pagination } from 'swiper/modules'
import 'swiper/swiper-bundle.css'

document.addEventListener( 'DOMContentLoaded', () => {
const dcImageSlider = document.querySelectorAll('.swiper');

  for( let i=0; i < dcImageSlider.length; i++ ) {
    // console.log(dcImageSlider);
    // const autoplay = dcImageSlider.dataset.autoplay;
    // console.log(autoplay);
    dcImageSlider[i].classList.add('swiper-' + i);

    new Swiper('.swiper-' + i, {
      modules: [ Autoplay ],
      direction: 'horizontal',
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
      // slidesOffsetAfter: 1,
      autoplay: {
        delay: 5000,
      },
      speed: 1000,
      slidesPerView: 1.1,
      spaceBetween: 30,
      freeMode: true,
      centeredSlides: false,
      loop: true,
      breakpoints: {
        640: {
          slidesPerView: 1.4,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1.8,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 2.3,
          spaceBetween: 50,
        }
      }
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: true,
      // },
    });

  }
})
